
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"4.364"}}),_c('path',{attrs:{"d":"M16 5.091A17.2 17.2 0 000 16c3.468 8.837 13.443 13.189 22.279 9.721A17.188 17.188 0 0032 16 17.2 17.2 0 0016 5.091zm0 18.182a7.273 7.273 0 110-14.546A7.273 7.273 0 0123.273 16 7.275 7.275 0 0116 23.273z"}})])
          )
        }
      }
    